module.exports = __webpack_public_path__ + "img/contacts.1942e507.svg";